export default "__VITE_ASSET__Deeb45fp__"